module.exports = __webpack_public_path__ + "static/media/mobile-check-hand.9cb60c1d.svg";